import React, { useContext, useEffect, useState } from 'react';
import MainApp from './MainApp';

const ChatMiddleware = (props: any) => {
  return <MainApp {...props} />;
};

export default ChatMiddleware;
